import { injectGlobal } from 'emotion';
import { Theme } from '@surveycake/rc';
import { useDidMount } from '@surveycake/rhooks';

export function useGlobalStyles(theme: Theme) {
  useDidMount(() => {
    injectGlobal`
      body {
        color: ${theme.survey.color.default};
        background-color: ${theme.survey.color.light};
      }
    `;
  });
}
